import React from 'react';
import styles from './Description.module.scss';
import { sanitizeType } from '../../../../functions';

const Description = ({ api, type, animationData }) => {
  return (
    !!api?.attributes?.description && (
      <p
        data-aos={animationData?.animation}
        data-aos-offset={animationData?.animationOffset}
        data-aos-delay={animationData?.animationDelay}
        data-aos-duration={animationData?.animationDuration}
        data-aos-easing={animationData?.animationEasing}
        className={`${styles.sectionDesc} ${sanitizeType(type, styles)}`}
        dangerouslySetInnerHTML={{ __html: api.attributes.description }}
      />
    )
  );
};
export default Description;
